"use client"

import { FeedbackDialog } from "@/components/feedback/FeedbackDialog"
import { HistoryButton } from "@/components/nav/HistoryPanel"
import { LanguageSwitcher } from "@/components/nav/LanguageSwitcher"
import { ThemeToggle } from "@/components/nav/ThemeToggle"
import { useUser } from "@/context/UserContext"

/**
 * The app's own buttons — theme, language, history, feedback — without the account button, which
 * always stands apart.
 *
 * One component so the header can show them in its row on a wide screen, and the page's toolbar can
 * fold them into its ⋯ on a phone (see Toolbar and AppHeader), with the same buttons either way.
 */
export function AppControls({ isApp }: { isApp: boolean }) {
  const user = useUser()
  return (
    <>
      <ThemeToggle size="icon" />

      {/*
        The APP's language. Here rather than in the reader's toolbar, where it started: it is a
        setting for the whole app, and a reader who wanted the interface in French had to find a
        judgment first in order to say so.

        Unconditional, unlike the feedback button beside it — that one needs a session because it
        writes a row, and this one writes a cookie. Someone reading a judgment signed out is exactly
        the person most likely to need it in their own language.
      */}
      <LanguageSwitcher />

      {/*
        Signed in only, but on every page rather than only the app ones: the history is the reader's
        own work, and the moment they most want it back is when they are somewhere that is not the
        page they left it on.
      */}
      {user && <HistoryButton />}

      {/*
        Signed in only. `user_feedback.user_id` is NOT NULL, so POST /api/feedback answers 401
        without a session and there is no way to store what an anonymous visitor writes — the button
        was being offered on every app page to readers for whom it could only ever fail. Accepting
        anonymous feedback would mean making that column nullable first.
      */}
      {isApp && user && <FeedbackDialog />}
    </>
  )
}
